import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { updateUserAccessMessage } from "src/components/common/AccessMessage";
import { AppDispatch } from "src/store";

export const checkGetProperty = (obj: any, key: any) => {
  if (obj && Object.prototype.hasOwnProperty.call(obj, key) && obj[key]) return obj[key];
  return undefined;
};

export const updateUserAccess = (error: FetchBaseQueryError | SerializedError | undefined, dispatch: AppDispatch) => {
  if (error) {
    const status = checkGetProperty(error, 'status');
    if (status === 404) {
      console.log(error);
    } else {
      updateUserAccessMessage({ status, dispatch });
    }
  }
}

export interface KeyValue {
  key: any;
  value: any;
}
export const formatString = (str: string, ...args: KeyValue[]): string => {
  for (const k in args) {
    str = str.replace(new RegExp('\\{' + args[k].key + '\\}', 'gi'), args[k].value);
  }
  return str;
};